export const exportJson = <T>(data: T, fileName: string) => {
  // Pretty print with 2-space indentation
  const jsonString = JSON.stringify(data, null, 2);

  const blob = new Blob([jsonString], { type: "application/json" });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;

  // for firefox adaptation
  document.body.appendChild(link);

  link.click();

  // clean DOM
  document.body.removeChild(link);

  URL.revokeObjectURL(link.href);
};
